import React from 'react';

const VendorAgreementContent = () => {
  return (
    <div>
      <div className="text-center bold">
        <p>OnGo&trade; CERTIFICATION PROGRAM</p>
        <p>VENDOR PARTICIPATION AGREEMENT</p>
      </div>
      <p>
        CAREFULLY READ ALL OF THE TERMS AND CONDITIONS OF THIS OnGo&trade;
        CERTIFICATION PROGRAM VENDOR PARTICIPATION AGREEMENT (THE “AGREEMENT”)
        BEFORE CLICKING THE “I ACCEPT” BUTTON. BY CLICKING THE “I ACCEPT”
        BUTTON: (I) VENDOR (DEFINED BELOW) IS AGREEING TO THE TERMS AND
        CONDITIONS OF AND IS BECOMING A PARTY TO THIS AGREEMENT WITH CBRS
        ALLIANCE; (II) THE INDIVIDUAL CLICKING “I ACCEPT” BELOW (“SIGNATORY”)
        REPRESENTS AND WARRANTS TO CBRS ALLIANCE THAT SIGNATORY IS VENDOR’S
        EMPLOYEE AND IS AUTHORIZED TO LEGALLY BIND VENDOR TO THE TERMS AND
        CONDITIONS OF THIS AGREEMENT; (III) VENDOR ACKNOWLEDGES, AGREES, AND
        REPRESENTS AND WARRANTS TO CBRS ALLIANCE THAT: (A) VENDOR HAS READ AND
        UNDERSTANDS THIS AGREEMENT; (B) CBRS ALLIANCE MAY REJECT OR TERMINATE
        THIS AGREEMENT IF VENDOR FAILS TO SATISFY ANY OF THE TERMS OR CONDITIONS
        HEREOF; AND (C) THIS AGREEMENT IS A LEGALLY BINDING CONTRACT BETWEEN
        VENDOR AND CBRS ALLIANCE EFFECTIVE AS OF THE DATE THE “I ACCEPT” BUTTON
        IS CLICKED. FOR PURPOSES OF THIS AGREEMENT, “VENDOR” MEANS THE CBRS
        ALLIANCE MEMBER ENTITY THAT EMPLOYS SIGNATORY. IF VENDOR DOES NOT AGREE
        TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, THEN NEITHER
        VENDOR NOR SIGNATORY IS AUTHORIZED TO PARTICIPATE IN THE PROGRAM
        (DEFINED BELOW), AND ACCORDINGLY, SHOULD CLICK THE “DO NOT ACCEPT”
        BUTTON AND EXIT THIS PAGE.
      </p>
      <p>
        For good and valuable consideration, the receipt and sufficiency of
        which is hereby acknowledged, Vendor and CBRS (each a “Party” and
        collectively, the “Parties”) Alliance hereby agree to the foregoing and
        as follows:
      </p>
      <div className="text-center bold">
        <p>1. BACKGROUND</p>
      </div>
      <p>
        1.1 CBRS Alliance is a non profit trade association that operates the
        “OnGo&trade; Certification Program” (the “Program”), for purposes of enabling
        the testing, verification and certification of wireless devices,
        components or other related equipment that incorporate CBRS Alliance
        technology and specifications (each a <b>“CBRS Device”</b>) for
        compliance against applicable Program Requirements (defined below).
      </p>
      <p>
        1.2 As part of the Program, to help ensure the independent testing and
        verification of CBRS Devices:
      </p>
      <ul style={{ listStyleType: 'none ' }}>
        <li>
          (a) The entity charged with responsibility for administering the
          Program (the <b>“Administrator”</b>) (which may be CBRS Alliance or a
          third party designated by CBRS Alliance for such purpose) selects and
          validates independent, industry-recognized FCC approved testing
          laboratories (each an <b>“ATL”</b>) to perform Testing (defined
          below);
        </li>
        <li>
          (b) With respect to each CBRS Device for which Vendor seeks
          Certification, Vendor is required to submit to CBRS Alliance, through
          a portion of the CBRS Alliance members’ only web portal designated for
          submission of Certification requests (the <b>“Portal”</b>
          ), a properly completed Certification request on the form provided by
          CBRS Alliance and made available through the Portal for such purpose
          (each a<b>“Certification Request”</b>
          ), including requisite information and details regarding the CBRS
          Device, which are then shared with the Administrator;
        </li>
        <li>
          (c) Upon confirmation from the Administrator, the Vendor must then
          submit such CBRS Device to an ATL for purposes of reviewing,
          evaluating and testing the CBRS Device for compliance against the
          applicable CBRS Alliance specifications (<b>“Specifications”</b>
          ), OnGo&trade; test plans and procedures (<b>“Test Plans”</b>
          ), requirements for certification of CBRS Devices under the Program (
          <b>“Certification”</b>) as set forth in the OnGo&trade; Certification
          Program Management Document (<b>“OnGo Certification PMD”</b>
          ), and such other requirements, policies and procedures as CBRS
          Alliance may establish from time to time in connection with the
          Program (such Specifications, Test Plans, requirements, policies and
          procedures, collectively, <b>“Program Requirements;”</b> and the
          review, evaluation and testing of CBRS Devices by ATLs for Program
          purposes, <b>“Testing”</b>
          );
        </li>
        <li>
          (d) Upon successful satisfaction of all applicable Program
          Requirements with respect to a given CBRS Device, including but not
          limited to payment of applicable certification fees to CBRS Alliance
          as specified in the Portal or on the CBRS Alliance web site (each a
          <b>“Certification Fee”</b>
          ), and uploading of the corresponding completed test results of the
          OnGo&trade; Test Plan (<b>“Test Report”</b>) into the OnGo&trade; Certification
          Database (<b>“Database”</b>) within the Portal by the ATL performing
          the Testing, the Administrator will notify Vendor and CBRS Alliance,
          acknowledging that the CBRS Device has satisfied all Program
          Requirements, and CBRS Alliance will perform a final Certification
          review; and
        </li>
        <li>
          (e) Upon successful completion of such Certification review: (i) CBRS
          Alliance or the Administrator will notify Vendor that such CBRS Device
          has achieved Certification (each CBRS Device achieving Certification,
          an <b>“Approved Device”</b>) (subject to continued compliance with the
          terms of this Agreement and applicable Program Requirements); and (ii)
          if elected by Vendor, such CBRS Device will be identified on such list
          of Approved Devices that CBRS Alliance may publish on its web site
          (the
          <b>“Approved CBRS Device List”</b>
          ).
        </li>
      </ul>
      <p>
        1.3 Vendor desires to enter into this Agreement for purposes of
        participating in the Program, submitting one or more CBRS Devices
        manufactured by or for Vendor for testing, and if successful,
        Certification of such CBRD Device(s).
      </p>
      <div className="text-center bold">
        <p>2. CBRS DEVICE OBLIGATIONS</p>
      </div>
      <p>
        2.1 Vendor shall ensure that Vendor, and each unit of each Approved
        Device that it sells, shall comply with all applicable Program
        Requirements. Vendor acknowledges that prior to Certification, it will,
        among other things, be required to pay applicable Certification Fees to
        CBRS Alliance for each CBRS Device submitted by Vendor. In the event a
        given CBRS Device submitted by Vendor for Certification fails to achieve
        Certification, CBRS Alliance will refund the corresponding Certification
        Fee paid by Vendor. Additionally, Vendor acknowledges that prior to
        Testing, Vendor will be required to pay an applicable Testing fee for
        each submitted CBRS Device to the applicable ATL, and that CBRS Alliance
        does not set, establish or determine corresponding pricing or pricing
        policies regarding fees charged by ATLs.
      </p>
      <p>
        2.2 Vendor assumes sole and exclusive responsibility for any use or
        reference to its CBRS Devices.
      </p>
      <p>
        2.3 Vendor agrees that any tests or sampling of any Vendor CBRS Device
        conducted as part of the Program is only a check as to whether such CBRS
        Device complies with Program Requirements and in no way releases Vendor
        from responsibility for such CBRS Device, including but not limited to
        any liabilities, claims, damages, or costs related to such CBRS Device,
        regardless of whether such CBRS Device is an Approved Device.
      </p>
      <p>
        2.4 If at any point after Certification, CBRS Alliance determines, in
        its sole but reasonable discretion, that any CBRS Device that achieved
        Certification does not comply with, in whole or in part, all applicable
        Program Requirements (<b>“Noncompliant CBRS Device”</b>
        ), CBRS Alliance reserves the right to revoke such Certification and
        remove such CBRS Device from the Approved CBRS Device List. The
        Administrator or CBRS Alliance shall notify Vendor, and Vendor shall
        immediately and at its own expense, remove, delete, or destroy any
        references to CBRS Alliance or Certification thereof in connection with
        the Noncompliant CBRS Device, including but not limited to any
        corresponding covenants, obligations, representations, or warranties.
      </p>
      <p>
        2.5 If at any point after Certification, Vendor determines that any CBRS
        Device that achieved Certification is a Noncompliant CBRS Device, Vendor
        shall immediately notify CBRS Alliance. Vendor shall comply with all
        applicable laws and regulations governing recall of any Vendor CBRS
        Device.
      </p>
      <p>
        2.6 Vendor shall notify CBRS Alliance of its decision to rework, recall,
        or cure any Noncompliant CBRS Device, within a reasonable period of time
        from Vendor’s decision. All rights, interests, and permissions granted
        herein with respect to any Approved Device that is a Noncompliant CBRS
        Device shall immediately cease and be suspended until such Noncompliant
        CBRS Device is reworked and cured to CBRS Alliance’s satisfaction and is
        no longer deemed a Noncompliant CBRS Device, which CBRS Alliance will
        acknowledge in a written notification to Vendor after determination
        thereof.
      </p>
      <p>
        2.7 Vendor agrees that upon written request of CBRS Alliance or the
        Administrator, Vendor will use best efforts to cooperate with and assist
        CBRS Alliance, the Administrator, or their authorized third-party agents
        and contractors, including but not limited to applicable ATLs, in
        ascertaining the facts needed to determine whether any Vendor CBRS
        Device complies with applicable Program Requirements.
      </p>
      <p>
        2.8 Vendor agrees that CBRS Alliance may notify vendors, authorities,
        potential users, and others of an improper or unauthorized reference to
        CBRS Alliance and/or Certification of any Vendor CBRS Device, provided
        that such notification is (1) made to protect CBRS Alliance’s property,
        brand, reputation, or other assets; (2) a matter of public interest; or
        (3) otherwise necessary for the protection of CBRS Alliance’s legitimate
        business or legal interests.
      </p>
      <div className="text-center bold">
        <p>3. OWNERSHIP AND INTELLECTUAL PROPERTY</p>
      </div>
      <p>
        3.1 Vendor acknowledges and agrees that all right, title, and interest
        in and to the Specifications, Test Plans, OnGo Certification PMD,
        Program webpage, Database, and any other materials, requirements,
        policies, procedures, technology, trademarks, service marks, logos or
        rights made available or used by or on behalf of CBRS Alliance in
        connection with the Program (collectively,{' '}
        <b>“Intellectual Property”</b>) are and shall be the exclusive property
        of CBRS Alliance or its third party licensors. Vendor acknowledges and
        agrees that nothing in this Agreement provides or shall be construed to
        provide to Vendor any right, title of interest in any of the
        Intellectual Property, and that except to the extent otherwise expressly
        set forth in a separate written agreement, CBRS Alliance expressly
        reserves all such rights, title and interest.
      </p>
      <p>
        3.2 As between the Parties, Vendor shall own all right, title, and
        interest to its Test Reports, provided that Vendor hereby grants to CBRS
        Alliance the non-exclusive, fully-paid, royalty-free worldwide,
        perpetual license to use Vendor’s Test Reports as necessary to
        administer, operate, manage, and maintain the Program and to perform (or
        enable its designees to perform) its obligations thereunder and under
        this Agreement.
      </p>
      <p>
        3.3 Any rights granted herein are granted only to Vendor, and do not
        extend to Vendor’s shareholders, members, owners, parents, partners,
        related entities or other affiliates of Vendor. The rights and
        obligations of this Agreement shall run to the Parties and their
        respective successors and assigns.
      </p>
      <p>
        3.4 Without limiting the foregoing, Vendor shall not make any
        unauthorized, incomplete, inaccurate, or misleading reference to CBRS
        Alliance, any Vendor CBRS Device, the Program, any of the Program
        Requirements, or any Test Report (<b>“Unauthorized Reference”</b>
        ). If CBRS Alliance knows, or has reason to know, of an Unauthorized
        Reference by Vendor, Vendor shall immediately modify, cure, or
        discontinue such use so that it is not an Unauthorized Reference.
      </p>
      <p>
        3.5 Vendor acknowledges and agrees that CBRS Alliance may amend, modify,
        supplement, suspend or terminate the Program and/or any of the Program
        Requirements at any time upon written notice.
      </p>
      <div className="text-center bold">
        <p>4. TERM AND TERMINATION</p>
      </div>
      <p>
        4.1 This Agreement shall commence as of the date Vendor clicks “I
        ACCEPT” and shall continue so long as any Vendor CBRS Device is an
        Approved Device, unless sooner terminated as set forth in this Section.
      </p>
      <p>
        4.2 Vendor may terminate this Agreement at any time upon notice to CBRS
        Alliance. CBRS Alliance may terminate this Agreement (a) upon notice of
        such termination, if Vendor fails to comply with any of the terms and
        conditions of this Agreement after notice and failure to cure within the
        applicable cure period stated in such notice (if any), (b) upon written
        notice if CBRS Alliance terminates the Program, or (c) if CBRD
        determines, in its sole but reasonable discretion, that the continuation
        of this Agreement would cause CBRS Alliance to be in violation of any
        applicable law, statute, regulation, order, rule or requirement of any
        applicable governmental authority.
      </p>
      <p>
        4.3 Upon any such termination, the respective rights and obligations of
        the parties hereunder shall immediately cease and each Approved Device
        shall be removed from the Approved CBRS Device List, except that the
        parties respective rights and obligations pursuant to Sections 2.2, 2.8,
        3, 4.3, 5, 7 and 8, and any other provisions of this Agreement that are
        intended by their nature to survive termination of this Agreement, shall
        survive any termination of this Agreement for any reason.
      </p>
      <div className="text-center bold">
        <p>5. CONFIDENTIALITY</p>
      </div>
      <p>
        5.1 Confidential Information. For purposes of this Agreement,
        <b>“Confidential Information”</b> shall mean and include all information
        or materials relating to the business, affairs, products, services,
        customers or personnel of either Party hereto or any member, contractor,
        representative or customer thereof, to the extent disclosed by any of
        the foregoing in connection with this Agreement or the Program,
        including without limitation, programs, software, source code, object
        code, documentation, hardware, methods of processing, operational
        methods, pricing, customer and supplier lists, strategies, confidential
        information of third parties with which the Parties conduct business and
        any other information or materials exchanged in connection with the
        Program. Notwithstanding the foregoing, Confidential Information shall
        not include information that: (a) is or becomes generally known to the
        public other than due to a breach of this Agreement by the Receiving
        Party (defined below), (b) is rightfully in the possession of the
        Receiving Party prior to disclosure by the Disclosing Party (defined
        below) hereunder, (c) is received by the Receiving Party in good faith
        and without restriction from a third party not under a confidentiality
        obligation and having the right to make such disclosure, or (d) is
        independently developed by the Receiving Party without use of or
        reference to the Confidential Information of the Disclosing Party. For
        the avoidance of doubt and without limiting the foregoing, for purposes
        of this Agreement, the Specifications, Test Plans, this Agreement, and
        the terms and conditions hereof are deemed to be Confidential
        Information of CBRS Alliance, and Vendor’s Test Reports are deemed to be
        Confidential Information of Vendor.
      </p>
      <p>
        5.2 Obligations. The Parties acknowledge and agree that in connection
        with this Agreement or the Program, either Party (the “Disclosing
        Party”) may find it necessary or desirable to disclose to the other
        Party (the “Receiving Party”) Confidential Information of or relating to
        the Disclosing Party. Each Receiving Party hereby agrees that, without
        the prior written consent of the Disclosing Party in each instance,
        except to the extent otherwise contemplated by this Agreement, the
        Receiving Party shall: (i) treat all such Confidential Information as
        confidential; (ii) only use such Confidential Information for purposes
        of performing its obligations under or enjoying the benefits of this
        Agreement; and (iii) not disclose any such Confidential Information to
        any third party, other than its own members, employees, contractors or
        other representatives who (a) need to know such information in order to
        enable the Receiving Party to perform its obligations under this
        Agreement or enjoy the benefits of this Agreement and (b) have been
        instructed not to disclose or use such Confidential Information except
        as expressly permitted under this Agreement. Each Receiving Party shall
        be responsible and liable to the Disclosing Party for any use or
        disclosure of the Disclosing Party’s Confidential Information in
        violation of this Agreement, and shall ensure that its employee,
        contractors and other representatives comply with the restrictions
        hereof. Notwithstanding the foregoing, if the Receiving Party is
        required to disclose Confidential Information of the Disclosing Party in
        order to comply with any applicable law, regulation, court order or
        other legal, regulatory or administrative requirement, the Receiving
        Party shall promptly notify the Disclosing Party of such requirement and
        co-operate through all reasonable and legal means, at the Disclosing
        Party’s expense, in any attempts by the Disclosing Party to prevent or
        otherwise restrict disclosure of such information, and only disclose
        that portion of such Confidential Information as is ultimately legally
        required to be disclosed. Upon the termination of this Agreement, or the
        earlier request of the Disclosing Party, the Receiving Party shall, at
        the request of the Disclosing Party, deliver to the Disclosing Party,
        all Confidential Information of the Disclosing Party so requested (and
        copies thereof) to the extent in its possession or control, or at the
        election of the Disclosing Party, destroy the same and certify to the
        Disclosing Party as to such destruction.
      </p>
      <p>
        5.3 Remedies. Each Receiving Party acknowledges that immediate,
        extensive, and irreparable damage may result if the provisions of this
        Section 5 are not specifically enforced. Therefore, in addition to, and
        not in limitation of, any other remedy available to the Disclosing
        Party, the Disclosing Party may enforce this Section 5 in judicial
        proceedings by seeking a decree of specific performance by a court of
        competent jurisdiction and seek appropriate injunctive relief as may be
        applied for and granted in connection with such enforcement.
      </p>
      <div className="text-center bold">
        <p>6. NO APPROVAL</p>
      </div>
      <p>
        Nothing in this Agreement shall be interpreted or construed to
        constitute a guarantee, representation, or warranty by CBRS Alliance in
        connection with any Vendor CBRS Device. No representation by Vendor in
        connection with its use, marketing, sale, or distribution of any Vendor
        CBRS Device will directly or indirectly, explicitly or implicitly convey
        or suggest any such guarantee or warranty. CBRS Alliance reserves the
        right to require Vendor to include a statement disclaiming directly or
        indirectly CBRS Alliance’s guarantee, representation, or warranty in the
        marketing and informational materials associated with any Vendor CBRS
        Device.
      </p>
      <div className="text-center bold">
        <p>7. LIMITATION OF LIABILITY; INDEMNIFICATION</p>
      </div>
      <p>
        7.1 VENDOR ACKNOWLEDGES AND AGREES THAT IN NO EVENT SHALL CBRS ALLIANCE
        BE LAIBLE FOR ANY LOSS, DAMAGE, OR CLAIM, RELATED TO OR ARISING IN
        CONNECTION WITH VENDOR’S CBRS DEVICE, WHETHER LIABILITY IS ASSERTED IN
        CONTRACT, TORT (INCLUDING NEGLIGENCE AND STRICT LIABILITY), OR OTHER
        LEGAL THEORY. EXCEPT FOR THE INDEMNITIES PROVIDED FOR IN SECTION 7.2
        BELOW, IN NO EVENT WILL EITHER PARTY BE LIABLE TO THE OTHER PARTY, OR TO
        ANY OTHER THIRD PARTY, FOR ANY LOSS OF PROFITS, LOSS OF USE, LOSS OF
        PRODUCTION, LOSS OF GOODWILL, OR ANY INCIDENTAL, INDIRECT, SPECIAL,
        PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND.
      </p>
      <p>
        7.2 Vendor shall indemnify, defend and hold harmless CBRS Alliance and
        its officers, directors, employees, members, and agents (each an
        “Indemnified Party”), against any and all liability, loss, cost, damage,
        claims, suits or expenses (including reasonable attorneys’ fees and
        costs) of any kind whatsoever, arising in any way from any negligent or
        willful acts or omissions of, or any death, personal injury or damage to
        personal property caused by, Vendor, any agent, representative or
        employee thereof, or any of Vendor’s Equipment (whether before, during
        or after Testing or Certification) (each a “Claim”). The foregoing
        obligation is contingent in each instance upon the Indemnified Party
        notifying Vendor in writing of any such Claim promptly after the
        Indemnified Party first learns thereof and the Indemnified Party
        providing Vendor, at Vendor’s cost and expense, with such reasonable
        assistance and co-operation as Vendor may reasonably request from time
        to time in connection with the defense thereof; provided, however, that
        the Indemnified Party’s failure to so notify or assist Vendor shall not
        relieve Vendor of such obligation except and to the extent such failure
        has materially and adversely affected Vendor’s ability to defend against
        such claim; and provided further that Vendor shall not settle any such
        Claim without first obtaining a complete and total release of the
        Indemnified Party or the Indemnified Party’s prior written consent in
        each instance.
      </p>
      <div className="text-center bold">
        <p>8. MISCELLANEOUS</p>
      </div>
      <p>
        8.1 Notices. All notices required or permitted hereunder shall be given
        in writing and shall be addressed to the intended recipient as provided
        herein. Notices shall be effective upon receipt if delivered by
        certified or registered mail or one day after mailing if delivered by
        nationally recognized overnight courier service. If a party refuses
        delivery of a notice, it shall nevertheless be deemed to have received
        the notice for the purposes of this Agreement on the date of refusal.
        Either of the Parties may change its address for purposes hereof by
        written notice to the other in accordance with the provisions of this
        Section. Notwithstanding anything to the contrary, CBRS Alliance may
        provide any notice to Vendor by electronic mail or by posting to the
        Portal (with corresponding alert or notice by electronic mail), and such
        notice shall be deemed effective upon transmission or porting thereof.
      </p>
      <p>
        8.2 Assignment. Vendor shall not assign this Agreement or its rights, or
        delegate any of its duties or obligations under this Agreement to any
        other entity, without the prior written consent of CBRS Alliance, which
        shall not be unreasonably withheld or denied.
      </p>
      <p>
        8.3 Governing Law; Jurisdiction. This Agreement shall be governed and
        interpreted in accordance with the laws of the State of Delaware without
        regard to principles of conflicts of laws. The Parties agree to submit
        to the exclusive jurisdiction over all disputes hereunder in the
        appropriate federal or state courts in the State of Oregon.
      </p>
      <p>
        8.4 Arbitration. Unless unenforceable due to federal or state law, any
        controversy or claim, including, but not limited to, errors and
        omissions arising out of or relating to this Agreement or the breach
        thereof, shall be settled by arbitration in accordance with the rules,
        then in effect, of the American Arbitration Association ("AAA") or, if
        AAA shall refuse to arbitrate any such controversy, by such arbitrators
        as the Parties shall mutually agree upon. Judgment upon any award
        rendered by the arbitrators may be entered in any court having
        jurisdiction thereof. Any arbitration shall be held in the State of
        Oregon.
      </p>
      <p>
        THE PARTIES AGREE THAT ANY DISPUTE WILL BE ARBITRATED ON AN INDIVIDUAL
        BASIS; CLASS, REPRESENTATIVE, AND PRIVATE ATTORNEY GENERAL ARBITRATIONS
        AND ACTIONS ARE NOT PERMITTED. A Party may bring claims against the
        other Party only in that Party's individual capacity and may not
        participate as a class member or serve as a named plaintiff in any
        purported class, representative, or private attorney general proceeding.
        This arbitration provision does not permit, and explicitly prohibits,
        the arbitration of consolidated, class, or representative disputes of
        any form. In addition, although the arbitrator may award any relief that
        a court could award that is individualized to the claimant and would not
        affect other Party, no Party may seek, nor may the arbitrator award,
        non-individualized relief that would affect other Party. Further, the
        arbitrator may not consolidate or join more than one person's claims
        unless the Parties affirmatively agree in writing. If any of the
        prohibitions in the preceding paragraph is held to be unenforceable as
        to a particular claim, then that claim (and only that claim) must be
        severed from the arbitration and brought in court.
      </p>
      <p>
        8.5 Entire Agreement. This Agreement constitutes the entire agreement
        between the Parties concerning the subject matter hereof and supersedes
        all prior and contemporaneous agreements, and communications, whether
        oral or written, between the Parties relating to the subject matter of
        this Agreement and all past courses of dealing or industry custom. This
        Agreement may be amended only with the specific written consent of both
        Parties.
      </p>
      <p>
        8.6 Severability. If any court of law determines that any clause in this
        Agreement is unenforceable or void, that clause shall be deleted while
        the rest of this Agreement remains in force. Moreover, the Parties agree
        to replace the invalid provisions with a substitute provision that will
        satisfy the intent of the Parties.
      </p>
      <p>
        8.7 No Waiver. The waiver by either Party of any breach of any provision
        of this Agreement shall not be construed to be either a waiver of either
        Party’s rights regarding any succeeding breach of any such provision or
        a waiver of the provision itself, nor shall any delay or omission on the
        part of either Party to exercise or avail itself of any right, power or
        privilege that it has, or may have hereunder, operate as a waiver of any
        right, power or privilege by either Party.
      </p>
    </div>
  );
};

export default VendorAgreementContent;



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Agreements/VendorAgreementContent.js